<template>
  <div class="page-layout">
    <PageHeader/>
    <div class="content">
      <slot/>
    </div>
  </div>
</template>

<script setup lang="ts">
import PageHeader from "@/components/PageHeader.vue";
</script>
